/** @typedef {import('@/types/tracking').TrackingData} TrackingData */

import { Segment, Sift } from '@/app/users/tracking/index.js'
import store from '@/store/store.js'

/**
 * @param {import('node_modules/vue-router/types/index').Route} to
 */
function callTrackPageTransition(to) {
  if (!store.getters?.definitions?.enable_user_analytics) {
    return
  }

  Sift.trackPageView()

  /** @type {TrackingData} */
  const trackingData = {
    path: to.path,
    url: to.name,
    name: to.meta.pageTitle(),
    title: to.meta.pageTitle(),
  }

  Segment.page(trackingData)
}

export default callTrackPageTransition
